(() => {
  const weekdays = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
  const months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];

  function shippingLabel() {
    const date = new Date();
    date.setDate(date.getDate() + 2);
    return `${weekdays[date.getDay()]} ${date.getDate()}. ${months[date.getMonth()]}`;
  }

  function renderShippingDate(root = document) {
    const label = shippingLabel();
    root.querySelectorAll('[data-hh-ng-date]').forEach((node) => {
      node.textContent = label;
      node.dataset.hhNgRendered = 'true';
    });
  }

  function init() {
    renderShippingDate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => renderShippingDate(event.target));
  document.addEventListener('change', (event) => {
    if (event.target && (event.target.name === 'id' || event.target.name === 'options[]')) {
      window.setTimeout(() => renderShippingDate(), 0);
    }
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll('[data-hh-ng-date]').forEach((node) => {
      if (!node.dataset.hhNgRendered || /Beregner/i.test(node.textContent || '')) {
        renderShippingDate();
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
